import type { CulturalNote } from '@ellie/shared';

interface CulturalCornerProps {
  notes: CulturalNote[];
}

export function CulturalCorner({ notes }: CulturalCornerProps) {
  if (notes.length === 0) return null;

  return (
    <div className="wb-page">
      <div className="wb-block-header">
        <span className="wb-block-tag" style={{ background: 'var(--wb-native)' }}>
          Cultural Corner
        </span>
        <h2 className="wb-block-title">Cultural Corner</h2>
        <p className="wb-block-subtitle">Things that are useful to know</p>
      </div>

      <div className="wb-cultural-cards">
        {notes.map((note, i) => (
          <div key={i} className="wb-cultural-card">
            <h3>
              {note.emoji} {note.title}
            </h3>
            <p className="wb-subtitle">{note.titleNative}</p>
            <p>{note.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
